_getEventComplete